import { useSummary } from '@composables/common'
import { PaymentAccount } from '@src/types/PaymentAccount'
import { SummaryItem } from '@src/types/Summary'
import { Ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

export function usePaymentAccountSummary(
    paymentAccount: Ref<PaymentAccount | null>
) {
    const i18n = useI18n()

    const items = computed<SummaryItem[]>(() => {
        return [
            {
                label: i18n.t('id'),
                value: paymentAccount?.value?.id,
                special: 'link',
                linkURL: `/payment-accounts/${paymentAccount?.value?.id}`,
                copy: true,
            },
            {
                label: i18n.t('name'),
                value: paymentAccount?.value?.name,
                special: 'link',
                linkURL: `/payment-accounts/${paymentAccount?.value?.id}`,
                copy: true,
            },
            {
                label: i18n.t('type'),
                value: paymentAccount?.value?.type,
            },
            {
                label: i18n.t('description'),
                value: paymentAccount?.value?.description,
            },
        ]
    })

    const { Summary: PaymentAccountSummary } = useSummary(items, {
        title: i18n.t('payment_account_summary'),
    })

    return {
        PaymentAccountSummary,
    }
}
